import LogoSmartCity from "images/logo-smart-city.svg";
import LogoTainan from "images/logo-tainan.svg";
import { useWebCountQuery } from "services/api";

const BaseFooter = () => {
  const relativeWebs = [
    {
      title: "臺南市政府全球資訊網",
      url: "https://www.tainan.gov.tw",
    },
    {
      title: "網站資料開放宣告",
      url: "https://data.tainan.gov.tw/webdataopen",
    },
    {
      title: "臺南市政府開放資料平台",
      url: "https://data.tainan.gov.tw/",
    },
    {
      title: "隱私權保護使用及資訊安全政策",
      url: "https://data.tainan.gov.tw/privacy",
    },
  ];

  const contact = [
    {
      title: "永華市政中心",
      info: `708201臺南市安平區永華路二段6號
          總機：(06)299-1111`,
    },
    {
      title: "民治市政中心",
      info: `730201臺南市新營區民治路36號
          總機：(06)632-2231`,
    },
    {
      title: "24小時市民服務熱線",
      info: `1999`,
    },
  ];

  const { data: webCount = 0 } = useWebCountQuery();

  return (
    <footer className="text-4 w-full rounded-3xl bg-grandma-400 px-5 pt-8 pb-10 text-white print:hidden md:flex md:flex-wrap md:justify-between md:py-10 md:px-[52px] xl:py-6 xl:px-10">
      <div className="md:flex-[0_0_calc(95% - 230px)] md:mb-8 lg:flex-initial">
        <h3 className="text-[14px] leading-10 md:font-thin">聯絡</h3>
        {contact.map((item) => (
          <div
            key={item.title}
            className="mb-4 border-b border-gray-100 border-opacity-10 pb-4 text-base md:mb-8 md:flex md:border-0 md:pb-0 md:last:mb-0"
          >
            <h4 className="mr-2 font-bold">{item.title}</h4>
            <div className="whitespace-pre-line">{item.info}</div>
          </div>
        ))}
      </div>
      <div className="mb-8 md:flex-[0_0_230px] lg:flex-initial">
        <h3 className="text-[14px] leading-10 md:font-thin">資料</h3>

        {relativeWebs.map((item) => (
          <div key={item.title} className="mb-1 md:mb-3">
            <a
              className="font-bold hover:border-b hover:border-amber-100 hover:text-amber-100"
              href={item.url}
            >
              {item.title}
            </a>
          </div>
        ))}
      </div>
      <div className="flex md:flex-[0_0_100%] xl:mt-0 xl:flex-initial xl:flex-col">
        <div className="flex-auto">
          <h3 className="text-[14px] leading-10 md:mb-2 md:font-thin">
            瀏覽人次
          </h3>

          <div className="mr-6 inline-flex h-12 items-center justify-end rounded-xl bg-white px-5 font-bold text-black md:mb-0">
            {webCount.toLocaleString()} <small className="pl-1">人</small>
          </div>
        </div>
        <div className="flex items-end justify-between">
          <div className="mr-8 hidden md:block">
            <img className="h-12" src={LogoSmartCity} alt="台南智慧城市" />
          </div>
          <div>
            <img className="h-15" src={LogoTainan} alt="台南市政府" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default BaseFooter;
